<script setup>
const tech = useTech()

const techTheme = useTechTheme()
const currentTheme = computed(() => techTheme.lowestLevelTheme?.value)
</script>
<template>
  <NuxtLink
    :to="`${tech?.id ? `/${tech.id}` : ''}/logout`"
    class="font-bold text-quartz dark:text-body-text"
    :class="[currentTheme?.textColorHover || 'hover:text-azure-radiance']">
    Logout
  </NuxtLink>
</template>
